// EasyAuth handles all authentication - no MSAL needed!

function getAppOrigin(): string {
  return window.location.origin;
}

export async function login() {
  // Check if we're running locally
  const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

  if (isLocal) {
    console.log('LOCAL DEVELOPMENT - No login required, redirecting to dashboard');
    window.location.href = '/dashboard';
    return;
  }

  // For production, redirect to Azure Function EasyAuth login endpoint
  const functionUrl = import.meta.env.VITE_FUNCTION_URL;
  const functionBaseUrl = functionUrl.replace('/api', '');

  const redirectUri = encodeURIComponent(`${getAppOrigin()}/dashboard`);
  window.location.href = `${functionBaseUrl}/.auth/login/aad?post_login_redirect_uri=${redirectUri}`;
}

export async function logout() {
  // Redirect to EasyAuth logout endpoint on the Function App domain
  const functionUrl = import.meta.env.VITE_FUNCTION_URL;
  const functionBaseUrl = functionUrl.replace('/api', '');

  const redirectUri = encodeURIComponent(`${getAppOrigin()}/login`);
  window.location.href = `${functionBaseUrl}/.auth/logout?post_logout_redirect_uri=${redirectUri}`;
}

export async function getToken(): Promise<string> {
  // EasyAuth handles tokens automatically - no need to get them manually
  return '';
}

export async function isAuthenticated(): Promise<boolean> {
  try {
    // Check if we're running locally
    const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

    if (isLocal) {
      console.log('LOCAL DEVELOPMENT - No authentication required');
      return true; // Skip authentication for local development
    }

    // For production (Static Web Apps), try to call the API directly - if it works, we're authenticated
    const apiUrl = import.meta.env.VITE_FUNCTION_URL;
    console.log('Checking authentication with:', `${apiUrl}/dashboard`);

    const response = await fetch(`${apiUrl}/dashboard`, {
      credentials: 'include'
    });

    console.log('Auth check response status:', response.status);
    console.log('Auth check response content-type:', response.headers.get('content-type'));

    // If we get a JSON response, we're authenticated
    // If we get HTML (login page), we're not authenticated
    const contentType = response.headers.get('content-type') || '';
    const isJsonResponse = contentType.includes('application/json');

    console.log('Is JSON response:', isJsonResponse);
    return response.ok && isJsonResponse;
  } catch (error) {
    console.log('Authentication check failed:', error);
    return false;
  }
}

export async function getUserInfo() {
  try {
    // For Static Web Apps, we'll get user info from the API response headers or a dedicated endpoint
    // For now, return a default user - the backend will have the real user info
    return {
      name: 'User',
      preferred_username: 'User'
    };
  } catch (error) {
    throw new Error('No authenticated user');
  }
}


